import axios from 'axios'
import {config} from '../config'
export const getMedia = () =>{
    return axios.get(config.press)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

